exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bottom___3sxCJ {\n  width: 80%;\n  background: #fafafa;\n  -webkit-box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.14);\n          box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.14);\n  border-radius: 6px;\n  padding: 10px 5%;\n  margin: 20px auto auto auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.bottomText___lHwaD {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-family: STKaitiSC-Regular;\n  font-size: 12px;\n  color: #666666;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: unset;\n}\n\n.text___1r8Nf {\n  font-family: STKaitiSC-Regular;\n  font-size: 12px;\n  color: #999999;\n  letter-spacing: 0;\n  margin: 5px 0 0 0;\n  line-height: 16px;\n  text-align: left;\n}\n.pText___1sJno {\n  font-family: STKaitiSC-Bold;\n  font-size: 12px;\n  color: #333333;\n  letter-spacing: 0;\n  margin: 0 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: end;\n      align-items: flex-end;\n}\n", ""]);

// exports
exports.locals = {
	"bottom": "bottom___3sxCJ",
	"bottomText": "bottomText___lHwaD",
	"text": "text___1r8Nf",
	"pText": "pText___1sJno"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Fp.css
// module id = 794
// module chunks = 2